import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3f99ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "inputFieldLabel" }
const _hoisted_3 = { for: "txtFirstName" }
const _hoisted_4 = {
  key: 0,
  class: "requiredField"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["id", "title"]
const _hoisted_7 = { class: "validation-error" }
const _hoisted_8 = ["id", "disabled"]
const _hoisted_9 = {
  key: 0,
  disabled: "",
  value: ""
}
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inputField", _ctx.cssClass]),
    id: `txt${_ctx.name}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.langKey)) + " ", 1),
        (_ctx.index != null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.index+1), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.hasTooltip)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: "/Portals/0/Images/tooltip.png",
            id: `tooltip${_ctx.name}`,
            class: "tooltip",
            title: _ctx.$t(`${_ctx.langKey}Tooltip`)
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_ErrorMessage, {
        name: _ctx.name,
        class: "error"
      }, {
        default: _withCtx(({ message }) => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(message!)), 1)
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_component_Field, {
        name: _ctx.name,
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input) = $event)),
        label: _ctx.$t(_ctx.langKey),
        rules: _ctx.rules
      }, {
        default: _withCtx(({ field }) => [
          _createElementVNode("select", _mergeProps(field, {
            id: `txt${_ctx.name}`,
            onInput: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value);_ctx.$emit('input', ($event.target as HTMLInputElement).value)}),
            class: ["input", {inputDisabled: _ctx.disabled}],
            disabled: _ctx.disabled
          }), [
            (_ctx.placeholder)
              ? (_openBlock(), _createElementBlock("option", _hoisted_9, _toDisplayString(_ctx.$t(_ctx.placeholder)), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(_ctx.$t(`${_ctx.langKey}Options.${option}`)), 9, _hoisted_10))
            }), 128))
          ], 16, _hoisted_8)
        ]),
        _: 1
      }, 8, ["name", "modelValue", "label", "rules"])
    ])
  ], 10, _hoisted_1))
}